/** Interval in milliseconds for updating call timer */
export const CALL_TIMER_INTERVAL_MS = 1000;